import { render, staticRenderFns } from "./CreateCourseModal.vue?vue&type=template&id=5ec4560f&scoped=true&"
import script from "./CreateCourseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourseModal.vue?vue&type=style&index=0&id=5ec4560f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4560f",
  null
  
)

export default component.exports